import React from "react";
import { Base64 } from "js-base64";
import moment from "moment";
import ALL_API_CONST from "./UrlAPI/index.jsx";
import { headerData } from "./UrlAPI/headerAuth";

const getIsLoggedIn = () => (localStorage.getItem("userDetails") ? "1" : "0");

const makeDataForLoggedIn = (data) => {
  try {
    return JSON.stringify({
      ...JSON.parse(data),
      user_type: "agent",
      is_loggedin: getIsLoggedIn(),
    });
  } catch (e) {
    console.error("Invalid JSON passed to makeDataForLoggedIn:", e);
    return data; // fallback to original data
  }
};

const originalFetch = window.fetch;

window.fetch = async (url, options = {}) => {
  const method = options.method?.toUpperCase() || "GET";

  if (method === "POST" && options.body) {
    options.body = makeDataForLoggedIn(options.body);
  }

  options.headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  return originalFetch(url, options);
};

export async function zonelistAccoData() {
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.zonelistAccoData,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function ActivityZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.ActivityZoneData,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function PackageZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.PackageZoneData,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferZoneData,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferSourceZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferSourceZoneData,

      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferDestinationZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferDestinationZoneData,

      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferAirportType() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferAirportType,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferFerryType() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferFerryType,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TransferCityType() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferCityType,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

//Zone List Airport to City

export async function TransferToAirportCityType(airporttocity) {
  let input = {
    airporttocity: airporttocity,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferToAirportCityType,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//Zone List City To Airport
export async function TransferCityToAirportType(citytoairport) {
  let input = {
    citytoairport: citytoairport,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferCityToAirportType,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//Zone List City To City
export async function TransferCityToCityType(citytocity) {
  let input = {
    citytocity: citytocity,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferCityToCityType,

      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function LiveAboardZoneData() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.LiveAboardZoneData,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getTourActivityList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourActivityList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourPackageList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourPackagelist,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourTransferList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourTransferlist,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourLiveAboardList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourLiveAboardList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export function renderMovieTitle(state, val) {
  return state.name.toLowerCase().indexOf(val.toLowerCase()) !== -1;
}

export async function HotelListData(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.HotelListData,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 0) {
      return result.data;
    } else {
      return "nohotel";
    }
  } catch (error) {
    throw error;
  }
}

export async function getHSHotellist(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.getHSHotellist,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 0) {
      return result.data;
    } else {
      return "nohotel";
    }
  } catch (error) {
    throw error;
  }
}

export async function HotelListDataById(data, query) {
  let input = {
    property_id: Base64.atob(data),
    querySearch: query,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.HotelListDataById,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();
    if (result.data.length > 0) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function HotelBookingRules(data, query, ratePlanCode, cart) {
  let input = {
    property_id: Base64.atob(data),
    querySearch: query,
    ratePlanCode: ratePlanCode,
    cart: cart,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.HotelBookingRules,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 0) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function TourRules(
  tourid,
  numberTravelerNew,
  ratePlanId,
  number,
  dateSelected,
  tour_operator_id = null
) {
  let input = {
    tour_id: Base64.atob(tourid),
    querySearch: numberTravelerNew,
    ratePlanCode: Base64.atob(ratePlanId),
    number: Base64.atob(number),
    dateSelected: dateSelected,
    tour_operator_id: tour_operator_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TourRules,

      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();
    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function HotelConfirmBooking(
  data,
  guest,
  GuestCont,
  EmailId,
  MobileNumber,
  MobileCode,
  StartDate,
  Enddate,
  customer_id,
  TransactionUUID
) {
  let input = {
    data: data,
    GuestDetails: guest,
    GuestCombination: GuestCont,
    GuestEmail: EmailId,
    GuestMobileNumber: MobileNumber,
    GuestCountryCode: MobileCode,
    startDate: StartDate,
    endDate: Enddate,
    customerId: customer_id,
    transaction_uuid: TransactionUUID,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.HotelConfirmBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setCustomerLogin(
  first_name,
  last_name,
  email,
  profile_image,
  birthday,
  gender,
  login_source,
  mobile_number,
  country,
  country_code,
  currency,
  ip_address,
  password,
  verified
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    email: email,
    profile_image: profile_image,
    birthday: birthday,
    gender: gender,
    login_source: login_source,
    mobile_number: mobile_number,
    country: country,
    country_code: country_code,
    currency: currency,
    ip_address: ip_address,
    password: password,
    verified: verified,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setCustomerLogin,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setCustomerAgentLogin(
  first_name,
  last_name,
  email,
  profile_image,
  birthday,
  gender,
  login_source,
  mobile_number,
  country,
  country_code,
  currency,
  ip_address,
  password,
  verified,
  agent_name = null,
  corporate_name = null,
  tax_registration = null,
  address = null,
  city = null,
  island = null,
  agent_country = null,
  zip_code = null,
  agent_image = null
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    email: email,
    profile_image: profile_image,
    birthday: birthday,
    gender: gender,
    login_source: login_source,
    mobile_number: mobile_number,
    country: country,
    country_code: country_code,
    currency: currency,
    ip_address: ip_address,
    password: password,
    verified: verified,
    agent_name: agent_name,
    corporate_name: corporate_name,
    tax_registration: tax_registration,
    address: address,
    city: city,
    island: island,
    agent_country: agent_country,
    zip_code: zip_code,
    agent_image: agent_image,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setCustomerAgentLogin,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setAgentSignup(
  first_name,
  last_name,
  email,
  mobile_number,
  country,
  country_code,
  currency,
  ip_address,
  password
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    email: email,
    mobile_number: mobile_number,
    country: country,
    country_code: country_code,
    currency: currency,
    ip_address: ip_address,
    password: password,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setAgentSignup,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setAgentUpdatePassword(email, password) {
  let input = {
    email: email,
    password: password,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setAgentUpdatePassword,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function setLoginConfirmationAgent(email) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setLoginConfirmationAgent,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setCustomerAgentLoginProfile(agent_image = null, email) {
  let input = {
    agent_image: agent_image,
    email: email,
  };

  // making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setCustomerAgentLoginProfile,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function registrationagentemailcheck(email) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.registrationagentemailcheck,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result;
  } catch (error) {
    throw error;
  }
}
export async function getCustomerLogin(email) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.getCustomerLogin,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getGeoInfo() {
  try {
    let question = await fetch("https://ipapi.co/json/", {
      method: "GET", //Request Type
    });
    let result = await question.json();

    return result;
  } catch (error) {
    throw error;
  }
}

export async function getUpcomingBooking(customer_id, booking_status) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getUpcomingBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noUpcoming";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getCancelledBooking(customer_id, booking_status) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getCancelledBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCancelled";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getCompletedBooking(customer_id, booking_status) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getCompletedBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCompleted";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function CancelBookingConfirm(Locator, PercentagePrice) {
  let input = {
    locator: Locator,
    cancellation_percentage: PercentagePrice,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CancelBookingConfirm,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function packageCancellationAPI(id) {
  let input = {
    agent_booking_id: id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.packageCancellation,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//HS Cancellation

export async function CancelBookingConfirmHs(hsbooking_id) {
  let input = {
    hsbooking_id: hsbooking_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CancelBookingConfirmHs,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function CancelBookingConfirmHl(hsbooking_id) {
  let input = {
    bookingid: hsbooking_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CancelBookingConfirmHl,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function LoginConfirmation(email, password) {
  let input = {
    email: email,
    password: password,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.LoginConfirmation,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function LoginAgentConfirmation(email, password) {
  let input = {
    email: email,
    password: password,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.LoginAgentConfirmation,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function LoginAdminTOAgentConfirmation(email) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.LoginAdminTOAgentConfirmation,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function ConfirmationForgot(email, password) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.ConfirmationForgot,

      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function ActivityDetailsData(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.ActivityDetailsData,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function CheckAvailabilityData(
  numberTraveler,
  checkDate,
  tour_id,
  price_type,
  transfertype
) {
  let input = {
    numberTraveler: numberTraveler,
    checkDate: checkDate,
    tour_id: tour_id,
    price_type: price_type,
    transfertype: transfertype,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.CheckAvailabilityData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );

    let result = await question.json();
      //  console.log(result.data);
    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function HomePageEventData() {
  try {
    let question = await fetch(
      "https://api.parrapi.com/api/atlas/products?key=853990929f594a01b5632e55514c96b4&cats=ATTRACTION,EVENT",
      {
        method: "GET", //Request Type
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHome() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHome,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeListing() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeListing,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//By Ranjeet
export async function getSpecialOffersForFilterHome() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForFilterHome,
      {
        method: "POST", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}


export async function getSpecialOfferEjuniferListing() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOfferEjuniferListing,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesFilters() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesFilters,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesAttractionFilters() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesAttractionFilters,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesPackageFilters() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesPackageFilters,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesTransferFilters() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesTransferFilters,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesLiveAboardFilters() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesLiveAboardFilters,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function PackageDetailsData(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.PackageDetailsData,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function TransferDetailsData(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.TransferDetailsData,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function LiveAboardDetailsData(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.LiveAboardDetailsData,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiences() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiences,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOfferEjunifer() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOfferEjunifer,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function getSpecialOffersForHomeExperiencesAttraction() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesAttraction,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesPackage() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesPackage,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesTransfer() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesTransfer,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSpecialOffersForHomeExperiencesLiveAboard() {
  try {
    let question = await fetch(
      ALL_API_CONST.offer_data.getSpecialOffersForHomeExperiencesLiveAboard,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getHotellistFilters(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.getHotellistFilters,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getHSHotellistFilters(data) {
  try {
    let question = await fetch("tour/getHSHotellistFilters", {
      method: "POST", //Request Type
      body: data,
      headers: {
        //Header Defination
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Authorization: "Basic YWRtaW46MTIzNA==",
        "x-api-key": "neeraj@123",
      },
    });
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourFilter(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourFilter,

      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourFilterTransfer(data) {

  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourFilterTransfer,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourFilterActivity(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourFilterActivity,

      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function getTourFilterPackage(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getTourFilterPackage,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function TourConfirmBooking(
  data,
  guest,
  GuestCont,
  EmailId,
  MobileNumber,
  MobileCode,
  StartDate,
  TourD,
  customer_id,
  TotalTourPrice,
  TransactionUUID,
  specialrequrement = null,
  returnrequrement = null
) {
  let input = {
    data: data,
    GuestDetails: guest,
    GuestCombination: GuestCont,
    GuestEmail: EmailId,
    GuestMobileNumber: MobileNumber,
    GuestCountryCode: MobileCode,
    startDate: StartDate,
    tourDetails: TourD,
    customerId: customer_id,
    totalPrice: TotalTourPrice,
    transaction_uuid: TransactionUUID,
    specialrequrement: specialrequrement,
    returnrequrement: returnrequrement,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.TourConfirmBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getAgentCommissionDetails(customer_id) {
  let input = {
    customer_id: customer_id,
  };
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getAgentCommissionDetails,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function getAgentDepositDetails(customer_id) {
  let input = {
    customer_id: customer_id,
  };
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getAgentDepositDetails,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getAgentAdditionChargesData(tour_operator_id) {
  let input = {
    tour_operator_id: tour_operator_id,
  };
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getAgentAdditionChargesData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function CartConfirmBooking(
  data,
  Guest,
  GuestCont,
  EmailId,
  MobileNumber,
  MobileCode,
  customer_id,
  TotalPrice,
  CommissionAmount,
  TransactionUUID,
  StartDate,
  Enddate,
  paylaterstatus
) {
  let input = {
    data: data,
    guest: Guest,
    GuestCombination: GuestCont,
    GuestEmail: EmailId,
    GuestMobileNumber: MobileNumber,
    GuestCountryCode: MobileCode,
    customerId: customer_id,
    totalPrice: TotalPrice,
    commionamount: CommissionAmount,
    transaction_uuid: TransactionUUID,
    startDate: StartDate,
    endDate: Enddate,
    paylater_status: paylaterstatus,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CartConfirmBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function CartConfirmBookingTesting(
  data,
  Guest,
  GuestCont,
  EmailId,
  MobileNumber,
  MobileCode,
  customer_id,
  TotalPrice,
  CommissionAmount,
  TransactionUUID,
  StartDate,
  Enddate,
  paylaterstatus
) {
  let input = {
    data: data,
    guest: Guest,
    GuestCombination: GuestCont,
    GuestEmail: EmailId,
    GuestMobileNumber: MobileNumber,
    GuestCountryCode: MobileCode,
    customerId: customer_id,
    totalPrice: TotalPrice,
    commionamount: CommissionAmount,
    transaction_uuid: TransactionUUID,
    startDate: StartDate,
    endDate: Enddate,
    paylater_status: paylaterstatus,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CartConfirmBookingTesting,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function cartConfirmBookingAgentZeroAmount(
  data,
  Guest,
  GuestCont,
  EmailId,
  MobileNumber,
  MobileCode,
  customer_id,
  TotalPrice,
  CommissionAmount,
  TransactionUUID,
  StartDate,
  Enddate,
  paylaterstatus
) {
  let input = {
    data: data,
    guest: Guest,
    GuestCombination: GuestCont,
    GuestEmail: EmailId,
    GuestMobileNumber: MobileNumber,
    GuestCountryCode: MobileCode,
    customerId: customer_id,
    totalPrice: TotalPrice,
    commionamount: CommissionAmount,
    transaction_uuid: TransactionUUID,
    startDate: StartDate,
    endDate: Enddate,
    paylater_status: paylaterstatus,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CartConfirmBookingTesting,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}


export async function WishlistCartAdd(
  plan_details,
  plan_name,
  agent_id,
  servicedate
) {
  let input = {
    plan_details: plan_details,
    plan_name: plan_name,
    agent_id: agent_id,
    service_date:servicedate
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
 // console.log(formBody);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.WishlistCartAdd,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function WishlistDelete(
  wishlist_id
) {
  let input = {
    wishlist_id: wishlist_id
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
 // console.log(formBody);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.WishlistDelete,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function getwishlistCartData(
  agent_id
) {
  let input = {
    agent_id: agent_id
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
 // console.log(formBody);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getwishlistCartData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getEventandActivity() {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getEventandActivity,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

//CyberSource Data

export async function CybersourecPaymentGetway(
  bill_to_forename,
  bill_to_surname,
  bill_to_email,
  access_key,
  profile_id,
  transaction_uuid,
  locale,
  transaction_type,
  reference_number,
  amount,
  currency
) {
  let input = {
    bill_to_forename: bill_to_forename,
    bill_to_surname: bill_to_surname,
    bill_to_email: bill_to_email,
    access_key: access_key,
    profile_id: profile_id,
    signed_field_names:
      "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,bill_to_forename,bill_to_surname,bill_to_email",
    unsigned_field_names: "",
    transaction_uuid: transaction_uuid,
    locale: locale,
    transaction_type: transaction_type,
    reference_number: reference_number,
    amount: amount,
    currency: currency,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  var url = CyberSource;
  var method = "POST";
  var postData = "Some data";
  var shouldBeAsync = true;

  var request = new XMLHttpRequest();
  request.onload = function () {
    var status = request.status; // HTTP response status, e.g., 200 for "200 OK"
    var data = request.responseText; // Returned data, e.g., an HTML document.
  };

  request.open(method, url, shouldBeAsync);

  request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  request.setRequestHeader("Access-Control-Allow-Origin", "*");
  request.setRequestHeader("Access-Control-Allow-Headers", "X-Requested-With");
  request.send(formBody);
  //
  // try {
  //     let question = await fetch(
  //         "Cybersource",
  //         {
  //             method: "POST", //Request Type
  //             body: formBody,
  //             headers: {
  //                 //Header Defination
  //                 "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  //                 Authorization: "Basic YWRtaW46MTIzNA==",
  //                 "x-api-key": "neeraj@123",
  //             },
  //         }
  //     );
  //     let result = await question.json();

  //     return result;

  // } catch (error) {
  //     throw error;
  // }
}

export async function getExprerianceUpcomingBooking(
  customer_id,
  booking_status
) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceUpcomingBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noUpcoming";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getExprerianceCancelledBooking(
  customer_id,
  booking_status
) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceCancelledBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCancelled";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getExprerianceCompletedBooking(
  customer_id,
  booking_status
) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceCompletedBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCompleted";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

//HS Cancellation

export async function CancelBookingConfirmHsTour(hstourbooking_id) {
  let input = {
    hstourbooking_id: hstourbooking_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.CancelBookingConfirmHsTour,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function UpdatePasswordReset(email, password) {
  let input = {
    email: email,
    password: password,
  };
  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.UpdatePasswordReset,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getExprerianceAgentBooking(customer_id, booking_status) {
  let input = {
    customer_id: customer_id,
    booking_status: booking_status,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceAgentBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noAgent";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getUpComingBookingAPI(customer_id) {
  let input = {
    customer_id: customer_id,
    booking_status: 1,
    booking_type: "upcoming",
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceAgentBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noUpcoming";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getCancelledBookingAPI(customer_id) {
  let input = {
    customer_id: customer_id,
    booking_status: 3,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceAgentBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCancelled";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getCompletedBookingAPI(customer_id) {
  let input = {
    customer_id: customer_id,
    booking_status: 1,
    booking_type: "complete",
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceAgentBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noCompleted";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function ConfirmationAgentForgot(email) {
  let input = {
    email: email,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.ConfirmationAgentForgot,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//Accomadation Booking ID Ejunfer Data

export async function getAccomadationBookingIdEJuniferData(
  property_id,
  data,
  ratePlanCode
) {
  let input = {
    property_id: property_id,
    querySearch: data,
    ratePlanCode: ratePlanCode,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.hotel_data.getAccomadationBookingIdEJuniferData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    
    let result = await question.json();
   
    if (result.data.length > 0) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function setCustomerAgentLoginProfileNew(formdata) {
  try {
    let question = await fetch(
      ALL_API_CONST.login_data.setCustomerAgentLoginProfileNew,
      {
        method: "POST", //Request Type
        body: formdata,
        headers: {
          //Header Defination
          "Content-Type": "multipart/form-data",
          Authorization: "Basic YWRtaW46MTIzNA==",
          "x-api-key": "neeraj@123",
        },
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

//Get Booking Confirmation Show

export async function getAccomodationShowDataBooking(transaction_uuid) {
  let input = {
    transaction_uuid: transaction_uuid,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getAccomodationShowDataBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noUpcoming";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getExprerianceShowDataBooking(transaction_uuid) {
  let input = {
    transaction_uuid: transaction_uuid,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.booking_data.getExprerianceShowDataBooking,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noUpcoming";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getExprerianceAgentBookingShowingPagination() {
  try {
    let question = await fetch(
      "tour/getExprerianceAgentBookingShowingPagination?customer_id=63&page=0",
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );

    let result = await question.json();

    if (Array.isArray(result.data) && !result.data.length) {
      return "noAgent";
    } else {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function checkAvailabilityCheckoutData(data) {
  let input = {
    data: data,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);

  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.checkAvailabilityCheckoutData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getalltransport(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.tour_data.getalltransport,

      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSubAgentListing(agent_id) {
  let input = {
    agent_id: agent_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.getSubAgentListing,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getSubagentBookingDetails(sub_agent_id) {
  let input = {
    sub_agent_id: sub_agent_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.getSubagentBookingDetails,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}


export async function setUserAgentRegister(
  first_name,
  last_name,
  email,
  mobile_number,
  country_code,
  password,
  customer_agent_id,
  checkdata
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    email: email,
    mobile_number: mobile_number,
    country_code: country_code,
    password: password,
    customer_agent_id: customer_agent_id,
    checkdata: checkdata,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.setUserAgentRegister,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserAgentListing(agent_id) {
  let input = {
    agent_id: agent_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.getUserAgentListing,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setUserAgentUpdate(
  first_name,
  last_name,
  mobile_number,
  country_code,
  user_id,
  password = null
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    mobile_number: mobile_number,
    country_code: country_code,
    user_id: user_id,
    password: password,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.setUserAgentUpdate,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setUserAgentUpdateData(
  first_name,
  last_name,
  email,
  mobile_number,
  country_code,
  customer_agent_id,
  checkdata,
  user_id,
) {
  let input = {
    first_name: first_name,
    last_name: last_name,
    email: email,
    mobile_number: mobile_number,
    country_code: country_code,
    customer_agent_id: customer_agent_id,
    checkdata: checkdata,
    user_id: user_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.setUserAgentUpdateData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function setUserAgentSoftDeleteData(user_id) {
  let input = {
    user_id: user_id,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //
  try {
    let question = await fetch(
      ALL_API_CONST.subagent.setUserAgentSoftDeleteData,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export const CyberSource  = ALL_API_CONST.cybersource;
export const SupplierUrl  = ALL_API_CONST.supplier;

// Package Plan API

export async function getHotellistInAdminPackageList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getHotellistInAdminPackageList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 0) {
      return result.data;
    } else {
      return "nohotel";
    }
  } catch (error) {
    throw error;
  }
}

export async function getTourLandTransferAdminPackageList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getTourLandTransferAdminPackageList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getTourTransferFerryAdminPackageList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getTourTransferFerryAdminPackageList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}
export async function getTourActivityAdminPackageList(data) {
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getTourActivityAdminPackageList,
      {
        method: "POST", //Request Type
        body: data,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}


export async function createAdminPackage(
  package_name,
  package_id,
  no_of_day,
  start_date,
  end_date,
  start_location,
  end_location,
  guest_combination,
  more_location
) {
  let input = {
    package_name: package_name,
    package_id: package_id,
    no_of_day: no_of_day,
    start_date: start_date,
    end_date: end_date,
    start_location: start_location,
    end_location: end_location,
    guest_combination: guest_combination,
    more_location: more_location,
  };
 
  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.createAdminPackage,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}


export async function getAdminPackageDetails(
  package_id
) {
  let input = {
    package_id: package_id
  };
 
  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getAdminPackageDetails,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function updateAdminPackage(
  package_name,
  package_id,
  more_location,
  category_id
) {
  let input = {
    package_name: package_name,
    package_id: package_id,
    more_location: more_location,
    category_id:category_id
  };
 
  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.updateAdminPackage,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getPackageCategory() {
  try {
    let question = await fetch(
      `${ALL_API_CONST.admin_package_data.getPackageCategory}?privacy_type=2`,
      {
        method: "GET", //Request Type
        headers: headerData,
      }
    );
    let result = await question.json();

    if (result.data.length > 1) {
      return result.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function createAdminPackageProperty(
  package_id,
  property_id,
  property_room_id,
  rate_plan_id,
  price,
  discount_percentage,
  start_date,
  end_date,
  adult_count,
  child_count,
  room_count,
  cart_data,
) {
  let input = {
    package_id: package_id,
    property_id: property_id,
    property_room_id: property_room_id,
    rate_plan_id:rate_plan_id,
    price: price,
    discount_percentage: discount_percentage,
    start_date: start_date,
    end_date: end_date,
    adult_count: adult_count,
    child_count: child_count,
    room_count:room_count,
    cart_data:cart_data,
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //console.log(formBody);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.createAdminPackageProperty,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function createAdminPackageExperience(
  package_id,
  experience_id,
  plan_id,
  price,
  discount_percentage,
  start_date,
  location,
  experience_time,
  adult,
  child,
  infant,
  youth,
  senior,
  group,
  experience_type,
  price_typeid,
) {
  let input = {
    package_id: package_id,
    experience_id: experience_id,
    plan_id: plan_id,
    price: price,
    discount_percentage: discount_percentage,
    start_date:start_date,
    location: location,
    experience_time: experience_time,
    adult: adult,
    child: child,
    infant:infant,
    youth:youth,
    senior:senior,
    group:group,
    experience_type:experience_type,
    price_typeid:price_typeid
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //console.log(formBody);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.createAdminPackageExperience,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}



export async function getAdminPackageDetailsListing(package_id) {
  let input = {
    package_id: package_id
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //console.log(formBody);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getAdminPackageDetailsListing,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getAdminPackageExprerianceDelete(package_exp_id) {
  let input = {
    pacex_id: package_exp_id
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //console.log(formBody);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getAdminPackageExprerianceDelete,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getAdminPackageAccomodationDelete(package_exp_id) {
  let input = {
    pacacco_id: package_exp_id
  };

  //making data to send on server
  const formBody = JSON.stringify(input);
  //console.log(formBody);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.getAdminPackageAccomodationDelete,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function updatePackagePrice(
  package_id,
  selling_price,
  discount_percentage,
  offer_description
) {
  let input = {
    package_id: package_id,
    selling_price: selling_price,
    discount_percentage: discount_percentage,
    offer_description:offer_description
  };
 
  //making data to send on server
  const formBody = JSON.stringify(input);
  try {
    let question = await fetch(
      ALL_API_CONST.admin_package_data.updatePackagePrice,
      {
        method: "POST", //Request Type
        body: formBody,
        headers: headerData,
      }
    );
    let result = await question.json();

    return result.data;
  } catch (error) {
    throw error;
  }
}



  export async function updatepackagecancellationmethods(
    package_id,
    policies,
    package_cancellation
  ) {
    let input = {
      package_id: package_id,
      policies: policies,
      package_cancellation: package_cancellation,
    };
    
    //making data to send on server
    const formBody = JSON.stringify(input);
    try {
      let question = await fetch(
        ALL_API_CONST.admin_package_data.updatepackagecancellationmethods,
        {
          method: "POST", //Request Type
          body: formBody,
          headers: headerData,
        }
      );
      let result = await question.json();
  
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  export async function getTourPackagePlanlist(data) {
    try {
      let question = await fetch(
        ALL_API_CONST.package_plan_data.getTourPackagePlanlist,
        {
          method: "POST", //Request Type
          body: data,
          headers: headerData,
        }
      );
      let result = await question.json();
  
      return result.data;
    } catch (error) {
      throw error;
    }
  }
  
  export async function getTourFilterPackagePlan(data) {
    try {
      let question = await fetch(
        ALL_API_CONST.package_plan_data.getTourFilterPackagePlan,
        {
          method: "POST", //Request Type
          body: JSON.stringify({...data, privacy_type: 2}),
          headers: headerData,
        }
      );
      let result = await question.json();
  
      return result.data;
    } catch (error) {
      throw error;
    }
  }
  
  export async function getPackageDetailsListing(data) {
    try {
      let question = await fetch(
        ALL_API_CONST.package_plan_data.getPackageDetailsListing,
        {
          method: "POST", //Request Type
          body: JSON.stringify({package_id: data}),
          headers: headerData,
        }
      );
      let result = await question.json();
  
      return result.data;
    } catch (error) {
      throw error;
    }
  }